<template>
  <div class="px-5 py-2 video-group">
    <!-- <div class="mr-5 mb-2">
        <searchComponent @selectedData="videos"></searchComponent>
    </div>      -->
    <b-row class="filter-container form-group">
      <b-col :md="!isPhysioSite ? 6 : 9" sm="12" class="pl-0 dropdown-group">
        <div class="d-flex select-group mb-2">
          <multiselect
              class="dropdown"
              v-if="!isPhysioSite"
              v-model="selectedCategories"
              :options="categoryOptions"
              placeholder="Select Category"
              :multiple="false"
              :close-on-select="true"
              label="category"
              :select-label="''"
              id="categories"
          ></multiselect>
          <multiselect
              class="dropdown item"
              v-model="selectedBodyFocus"
              :options="bodyFocusOptions"
              placeholder="Select Body Focus"
              :multiple="false"
              :close-on-select="true"
              label="category"
              :select-label="''"
              id="bodyfocus"
          ></multiselect>
          <multiselect
              class="dropdown item"
              v-model="selectedCondition"
              v-if="isPhysioSite"
              :options="conditionOptions"
              placeholder="Select Condition"
              :multiple="false"
              :close-on-select="true"
              label="category"
              :select-label="''"
              id="condition"
          ></multiselect>
          <div v-if="isPhysioSite" class="d-flex responsive-buttons physio-buttons">
          <b-button :class="{'bg-primary': selectedBodyFocus || selectedCategories || selectedCondition}" @click="filterData()">Apply</b-button>
          <b-button class="clear-btn" @click="clearfilter()">Clear</b-button>
        </div>
        </div>
        <div class="d-flex select-group">
          <template v-if="!isPhysioSite">
            <multiselect
                class="dropdown item"
                v-model="selectedDuration"
                :options="durationList"
                placeholder="Select Duration"
                :multiple="false"
                label="value"
                track-by="key"
                :close-on-select="true"
                id="duration"
            ></multiselect>
            <multiselect
                class="dropdown item"
                v-model="selectedCreator"
                :options="creatorList"
                placeholder="Select Creator"
                :multiple="false"
                :close-on-select="true"
                track-by="id"
                label="name"
                :select-label="''"
                id="creator"
            >
            </multiselect> 
          </template>
        </div> 
      </b-col>
      <b-col v-if="!isPhysioSite" md="3" sm="12" class="pl-0">
        <div  class="d-flex w-100 responsive-buttons">
          <b-button :class="{'bg-primary': selectedBodyFocus || selectedCategories || selectedDuration || selectedCreator}" @click="filterData()">Apply</b-button>
          <b-button class="clear-btn" @click="clearfilter()">Clear</b-button>
        </div>
      </b-col>
      <b-col md="3" sm="12" class="p-0">
        <div class="search-video" lg="6">
        <b-form-group
        >
          <b-input-group>
            <b-form-input
                id="filter-input"
                v-model="searchText"
                placeholder="Search Video"
                type="text"
            ></b-form-input>

            <b-input-group-append>
              <b-icon icon="search"></b-icon>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      </b-col>
    </b-row>
    <div class="d-flex">
      <!-- <b-col md="6" sm="12">
        <h6>
          Video Upload<input
            type="range"
            disabled
            :value="totalUploaded"
            min="0"
            :max="videoLimit"
        /><span class="ml-2"
        >{{ totalUploaded }}<span>/</span>{{ videoLimit }}</span
        >
        </h6>
      </b-col> -->
    </div>
    <div v-if="pinnedVideos.length > 0 && (isfilterActive ? showFeaturedVideosOnFilterApplied:true)">
      <div class="d-flex justify-content-between">
        <h3 class="pr-4">Featured Videos</h3>
        <button v-if="isfilterActive && showFeaturedVideosOnFilterApplied"
                  class="toggle-featured-videos" type="submit"
                  @click="showFeaturedVideosOnFilterApplied = false">Hide</button>
      </div>
      <div class="card-container">
        <b-row class="w-100">
          <div
            class="v-card col-lg-3 col-sm-6"
            v-for="(pinnedvideo, index) in pinnedVideos"
            :key="index"
            ref="workoutComponent"
          >
            <workout-component
              :id="pinnedvideo.id"
              :title="pinnedvideo.title"
              :thumbnail="pinnedvideo.thumbnail"
              :duration="pinnedvideo.duration"
              :tenantName="pinnedvideo.Tenant.name"
              :categories="pinnedvideo.VideoCategories"
              :description="pinnedvideo.description"
              :embed-id="pinnedvideo.youtube_embed_id"
              :featured="true"
              :workout-type="pinnedvideo.WorkoutType"
              :need-translation="pinnedvideo.needTranslation"
              @onPinSuccess="pinUnpin"
            ></workout-component>
            <div v-if="isPhysioSite" class="select-icon cursor-pointer" @click="toggleVideoSelected(pinnedvideo, index, true)">
              <b-icon v-if="!pinnedvideo.selected" icon="square" font-scale="1.5"></b-icon>
              <b-icon v-else class="checked" icon="check-square" font-scale="1.5"></b-icon>
            </div>
          </div>
        </b-row>
      </div>
    </div>
    <div class="pt-2 pb-3 d-flex flex-column flex-md-row justify-content-between">
      <div class="pr-4" v-if="!isPhysioSite"><h3>Elitefit.AI Library</h3></div>
      <h3 v-else class="h3 font-weight-bold">Select videos to create a program</h3>
      <div class="d-flex">
        <b-button v-if="selectedVideos.length" class="toggle-select-video" type="submit" variant="primary" @click="clearSelected">Clear Selection</b-button>
        <button v-if="pinnedVideos.length && isfilterActive && !showFeaturedVideosOnFilterApplied"
                  class="toggle-featured-videos ml-4" type="submit"
                  @click="showFeaturedVideosOnFilterApplied = true">Show Featured Videos</button>
      </div>
    </div>
    <div class="card-container">
      <b-row class="w-100">
        <div
          class="v-card col-lg-3 col-sm-6"
          v-for="(video, index) in videos"
          :key="index"
          ref="workoutComponent"
        >
          <workout-component
            :id="video.id"
            :title="video.title"
            :thumbnail="video.thumbnail"
            :duration="video.duration"
            :tenantName="video.Tenant.name"
            :categories="video.VideoCategories"
            :description="video.description"
            :embed-id="video.youtube_embed_id"
            :featured="false"
            :enable-pin-feature="enablePinFeature"
            :workoutType ="video.WorkoutType"
            :need-translation="video.needTranslation"
            @onPinSuccess="pinUnpin"
          ></workout-component>
          <div v-if="isPhysioSite" class="select-icon cursor-pointer" @click="toggleVideoSelected(video, index)">
            <b-icon v-if="!video.selected" icon="square" font-scale="1.5"></b-icon>
            <b-icon v-else class="checked" icon="check-square" font-scale="1.5"></b-icon>
          </div>
        </div>
      </b-row>
    </div>
    <b-pagination
      v-if="videos != null"
      align="center"
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
    >
    </b-pagination>
    <div v-if="noVideosFound" class="emptyVideos">
      <div>
        <h1>No result found</h1>
        <p>
          No content matched your criteria. Try searching for something else
        </p>
      </div>
    </div>

    <div class="assign-count-button cursor-pointer" @click="createProgramAndAssign" v-if="selectedVideos.length">
      <div>ASSIGN</div>
      <div class="selected-count notranslate"
           :style="{width: countCircleRadius + 'px', height: countCircleRadius + 'px', fontSize: countFontSize + 'px'}">{{selectedVideos.length}}</div>
    </div>
  </div>
</template>
<script>
import workoutComponent from "../../components/WorkoutComponent.vue";
import api from "../../api.js";
import filterIcon from "../../assets/icons/filter-horizontal.svg";
import Multiselect from "vue-multiselect";
import {createNamespacedHelpers} from "vuex";

const {
  mapGetters: mapThemeGetters
} = createNamespacedHelpers("themes");
const {
  mapGetters: mapLayoutGetters,
  mapMutations: mapLayoutMutations,
} = createNamespacedHelpers("dashboard/layout");

export default {
  name: "video-gallery",
  computed: {
    ...mapThemeGetters(["theme", "pages"]),
    ...mapLayoutGetters(["selectedVideos"]),
    name() {
      return this.theme[this.pages.SMB_PROGRAMS].name
    },
    rows() {
      return this.videosData.data.data.totalRecords
        ? this.videosData.data.data.totalRecords
        : 0;
    },
    countCircleRadius() {
      return 28 + this.selectedVideos.length * 0.1;
    },
    countFontSize() {
      return Math.max(8, 16 - this.selectedVideos.length * 0.0);
    },
    isfilterActive() {
      return Boolean(
          this.selectedDuration ||
          this.selectedCategories ||
          this.selectedCondition ||
          this.selectedBodyFocus ||
          this.selectedCreator ||
          this.searchText);
    }
  },
  components: {
    workoutComponent,
    filterIcon,
    Multiselect,
  },
  data: function() {
    return {
      videos: null,
      noVideosFound: false,
      videosData: null,
      pinnedVideos: [],
      currentPage: 1,
      perPage: 52,
      loaded: false,
      showVideo: false,
      allCategories: null,
      videoCategories: null,
      categories: {},
      userId: null,
      searchText: null,
      videoLimit: 0,
      totalUploaded: 0,
      durationList: [
        { key: 5, value: "5 Minutes" },
        { key: 10, value: "10 Minutes" },
        { key: 15, value: "15 Minutes" },
        { key: 20, value: "20 Minutes" },
        { key: 25, value: "25 Minutes" },
        { key: 30, value: "30 Minutes" },
        { key: 31, value: "More than 30 Minutes" },
      ],
      categoryOptions: [],
      bodyFocusOptions: [],
      conditionOptions: [],
      creatorList: [],
      selectedDuration: null,
      selectedCategories: null,
      selectedBodyFocus: null,
      selectedCondition : null,
      selectedCreator: null,
      is_free: null,
      selectVideoActive: false,
      enablePinFeature: true,
      isPhysioSite: false,
      showFeaturedVideosOnFilterApplied: false,
    };
  },
  methods: {
    ...mapLayoutMutations(["setSelectedVideos"]),
    async getAllTenantsName() {
      this.creatorList = await api.getAllTenants();
    },
    async generateCategoryList() {

      const userType = this?.isPhysioSite ? 'physio' : 'fitness' ;

      let categories = await api.getAllCategories(userType);


      if(userType === 'physio'){
        this.bodyFocusOptions = categories?.filter((category)=>!category?.is_condition)?.map((category)=>{
          return {
              id: category.id,
              category: category.name
          }
        })

        this.conditionOptions = categories?.filter((category)=>category?.is_condition)?.map((category)=>{
          return {
              id: category.id,
              category: category.name
          }
        })
      }
      else{
        for (let category of categories) {
        if (
          category.name.toLowerCase().includes("body") ||
          category.name.toLowerCase() == "core"
        ) {
          this.bodyFocusOptions.push({
              id: category.id,
              category: category.name
          });
        } else {
          this.categoryOptions.push({
              id: category.id,
              category: category.name
          });
        }
      }
      }
    },
    async getTrainerVideos() {
      if (this.enablePinFeature) {
        let pinnedVideosData = await api.getPinnedVideos();
        this.pinnedVideos = pinnedVideosData.data.rows;
      }
      this.userId = this.$store.state.userInfo.userId;
      this.videoLimit = this.$store.state.userInfo.corporate.subscription.video_limit;
      this.totalUploaded = await api.getCurrentUploadCount(this.userId);
      this.totalUploaded = this.totalUploaded[0].count;
      const requestData = this.getRequestData()
      this.videosData = await api.getEFVideos(requestData);
      this.videos = this.videosData.data.data.rows;
      this.loaded = true;
      this.updateWithSelected();
    },
    async searchVideo() {
      this.currentPage = 1;
      if (this.userId) {
        const requestData = this.getRequestData()
        this.videos = null;
        await api.getEFVideos(requestData).then(videos => {
          this.videosData = videos;
          this.videos = this.videosData.data.data.rows;
          this.noVideosFound = this.currentPage === 1 && !this.videos.length;
          this.updateWithSelected();
        }).finally(_ => {
          this.loaded = true;
        });
      }
    },
    async filterData() {
      const requestData = this.getRequestData()
      this.videosData = await api.getEFVideos(requestData);
      this.videosData.data.data.rows.map((videos, ind) => {
        const arr = []
        videos.VideoCategories.map((vid, inde) => {
          if(arr.indexOf(vid.WorkoutCategory.name) !== -1){
            this.videosData.data.data.rows[ind].VideoCategories.splice(inde, 1)
          }else{
            arr.push(vid.WorkoutCategory.name)
          }
        })
      })
      this.videos = this.videosData.data.data.rows;
      this.loaded = true;
      this.updateWithSelected();
    },
    getRequestData(){
      let categoryIds = [];
      let bodyFocus = "";
      let creators = "";
      let duration = "";
      let applyGreaterThan = false
      let videosearchText = "";
      if (this.searchText != null) {
        videosearchText = this.searchText;
      }
      if (this.selectedDuration != null) {
        if(this.selectedDuration.key === 31){
          duration = (this.selectedDuration.key-1) * 60;
          applyGreaterThan = true
        }else{
          duration = this.selectedDuration.key * 60;
        }
      }
      if (this.selectedCategories != null) {
        categoryIds.push(this.selectedCategories.id);
      }
      if (this.selectedCondition != null) {
        categoryIds.push(this.selectedCondition.id);
      }
      if (this.selectedBodyFocus != null) {
        bodyFocus += `${this.selectedBodyFocus.id}`;
      }
      if (this.selectedCreator != null) {
        creators += this.selectedCreator.id;
      }
      return {
        tenantId: creators,
        categoryIds: categoryIds.join(','),
        bodyFocus,
        duration,
        applyGreaterThan,
        pageSize: this.perPage,
        page: this.currentPage,
        searchText: videosearchText,
        lang : localStorage.getItem('lang')
      };
    },
    clearfilter() {
      this.selectedDuration = null;
      this.selectedCategories = null;
      this.selectedBodyFocus = null;
      this.selectedCreator = null;
      this.selectedCondition = null;
      this.getTrainerVideos();
    },
    async pinUnpin(videoID, isPinned) {
      if (isPinned) {
        this.videos = this.videos.filter((item) => item.id !== videoID);
      } else {
        await this.filterData();
      }
      let pinnedVideosData = await api.getPinnedVideos();
      this.pinnedVideos = pinnedVideosData.data.rows;
      this.updateWithSelected();
    },
    toggleSelectVideo() {
      this.selectVideoActive = !this.selectVideoActive;
    },
    toggleVideoSelected(video, idx, featured = false) {
      const alreadyExistIndex = this.selectedVideos.findIndex(sv => sv.id === video.id);
      const newSelectedVideos = [...this.selectedVideos];
      if (alreadyExistIndex === -1) newSelectedVideos.push(video);
      else newSelectedVideos.splice(alreadyExistIndex, 1);
      this.setSelectedVideos(newSelectedVideos);
      const selected = alreadyExistIndex < 0;
      if (!featured) {
        this.videos.splice(idx, 1, Object.assign({}, video, {selected}));
      } else {
        this.pinnedVideos.splice(idx, 1, Object.assign({}, video, {selected}));
      }
    },
    updateWithSelected() {
      this.pinnedVideos = this.pinnedVideos.map(pv => {
        const selected = this.selectedVideos.findIndex(sv => sv.id === pv.id) > -1;
        return Object.assign({}, pv, {selected})
      });
      this.videos = this.videos.map(v => {
        const selected = this.selectedVideos.findIndex(sv => sv.id === v.id) > -1;
        return Object.assign({}, v, {selected})
      });
    },
    clearSelected() {
      this.pinnedVideos = this.pinnedVideos.map(pv => {
        return Object.assign({}, pv, {selected: false})
      });
      this.videos = this.videos.map(v => {
        return Object.assign({}, v, {selected: false})
      });
      this.toggleSelectVideo();
      this.setSelectedVideos([]);
    },
    createProgramAndAssign() {
      this.$router.push({
        path: "/management/video/create-assign"
      })

    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getTrainerVideos();
      },
    },
    searchText: {
      handler() {
        if (this.searchText.length >= 3) {
          this.searchVideo();
        } else if (this.searchText.length == 0) {
          this.getTrainerVideos();
        }
      },
    },
    videos: {
      handler() {
          this.noVideosFound = this.videos?.length > 0 ? false : true
      },
    }
  },
  mounted() {
    const isPhysiotherapy = this.$store.state.userInfo?.corporate?.theme === "physiotherapy";
    if (isPhysiotherapy) {
      this.enablePinFeature = false;
      this.isPhysioSite = true;
    }
    this.getAllTenantsName();
    this.generateCategoryList();
    this.getTrainerVideos();
    const query = this.$route.query;
    this.selectVideoActive = query.selectVideo
        ? (query.selectVideo === 'true' || query.selectVideo === true) : false;
  },
};
</script>
<style lang="scss" scoped>
/* Styling for the slider track */
input[type="range"] {
  width: 20%;
  height: 10px;
  border-radius: 5px;
  margin-left: 20px;
}

.filter-container {
  display: flex;
  margin-left: 0px;
  margin-right: 0px;
  margin-bottom: 20px;
  row-gap: 16px;
}

.dropdown {
  flex: 1;
  background-color: #f0f0f0;
  margin-right: 10px;
  width: 100px;
  max-width: 50%;
}

.button {
  flex: 1;
  background-color: #e0e0e0;
  margin-right: 10px;
  height: 42.5px;
}

.input-text {
  flex-grow: 1;
  background-color: #d0d0d0;
  height: 42.5px;
}

.emptyVideos {
  margin-top: 25%;
  text-align: center;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-radius: 10px;
  align-content: left;
  background-color: #f4f6f9;
}

.v-card {
  margin-bottom: 45px;
  border-radius: 8px;
  padding: 16px;
  background-color: #f4f6f9;
}

.label {
  margin-right: 5px;
  margin-left: 20px;
  width: auto;
  border-color: #73bc44;
}

.clear-btn {
  margin-left: 10px;
}

.toggle-select-video, .toggle-featured-videos {
  padding: 8px 24px;
  background: #73bc44;
  border-radius: 25px;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  color: #ffffff;
  text-align: center;
  border: 0;
  max-width: 400px;
  white-space: nowrap;
  max-height: 41.59px;
}

.toggle-featured-videos {
  background: black;
}

.select-icon {
  position: absolute;
  top: 17px;
  right: 2px;
  width: 56px;
  height: 40px;
  padding: 4px 20px 12px 12px;
  border-radius: 0;
  background-color: transparent;
  z-index: 1;

  svg {
    background-color: #ffffff;
    border-radius: 4px;
  }
  .checked {
    background-color: #73bc44;
    border-radius: 0;
  }
}

.assign-count-button {
  position: fixed;
  bottom: 150px;
  right: 16px;
  z-index: 1;

  padding: 8px 24px;
  background: #73bc44;
  border-radius: 25px;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  color: #ffffff;
  text-align: center;
  border: 0;
  max-width: 400px;
  white-space: nowrap;

  display: flex;
  column-gap: 16px;
  align-items: center;

  .selected-count {
    width: 28px;
    height: 28px;
    font-size: 16px;
    padding: 2px;
    border-radius: 50%;
    border: 2px solid white;
    transition: all 0.3s ease;
  }
}

.search-video {
    input {
      border-right: none !important;
      outline: none !important;
      border-color: black !important;
      height: 40px;

      &:focus {
        outline: none;
        box-shadow: none;
      }
    }

    .input-group-append {
      justify-content: center;
      align-items: center;
      padding: 6px;
      border-style: solid;
      border-width: 1px 1px 1px 0;
      border-color: black;
      height: 40px;
      border-radius: 0 0.2rem 0.2rem 0;
      background-color: #ffffff;
    }
  }

@media screen and (max-width: 768px) {
  .video-group{
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .dropdown-group{
    padding-right: 0 !important;
    .select-group{
      flex-direction: column !important;
      .dropdown{
        width: auto ;
        margin-right: 0;
        max-width: 100%;
      }
      .item{
      margin-top: 1rem; 
      }
    padding-left: 0 !important;
  }
  }
  

  .responsive-buttons{
    justify-content: center;
  }

  .physio-buttons{
    margin-top: 1rem;
  }

  .multiselect__tags{
    border: none;
  }
}

@media screen and (max-width: 1024px) { 
  .dropdown-group{
    .select-group{
      .dropdown{
        max-width: 100%;
      }
  }
  }
}


</style>
